import useAuthStore from "../store/authStore";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://dtp.clcworld.in/api";
const API_BASE_URL_OLD =
  process.env.REACT_APP_API_BASE_URL_OLD || "https://r1.edkt.net/api";

const API_HOST = process.env.REACT_APP_API_HOST || "https://clcworld.in";
const ABC_BASE_URL = "https://abcschool.institute.org.in/api";

console.log(1);

const getLocalJson = (key) => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch (error) {
    return null;
  }
};

const normalizeResponse = (res) => {
  return res?.data || res;
};

const handleResponse = async (response) => {
  let data = null;

  try {
    data = await response.json();
  } catch (error) {
    data = null;
  }

  if (!response.ok) {
    if (response.status === 401) {
      useAuthStore.getState().logout();
    }

    throw new Error(
      data?.message ||
        data?.error?.message ||
        data?.error ||
        `API error: ${response.status} ${response.statusText}`,
    );
  }

  return data;
};

const getAuthData = () => {
  const state = useAuthStore.getState();

  const storeUser = state?.user;
  const storeClient = state?.client;
  const storeToken = state?.token;

  const localUser = getLocalJson("user");
  const localClient = getLocalJson("client");
  const localToken = localStorage.getItem("authToken");

  const token =
    storeToken ||
    storeUser?.token ||
    storeUser?.data?.token ||
    storeUser?.user?.token ||
    storeUser?.data?.user?.token ||
    localToken;

  const client = storeClient || localClient;

  const clientId =
    client?.id ||
    client?._id ||
    storeUser?.client ||
    storeUser?.user?.client ||
    localUser?.client;

  return {
    token,
    client,
    clientId,
  };
};

const getAuthHeaders = (isFormData = false, includeApiHost = false) => {
  const headers = {};

  if (!isFormData) {
    headers["Content-Type"] = "application/json";
  }

  const { token } = getAuthData();

  if (token) {
    headers["token"] = token;
  }
  if (includeApiHost) {
    headers["apihost"] = API_HOST;
  }

  return headers;
};

const apiService = {
  login: async (username, password) => {
    const response = await fetch(`${API_BASE_URL_OLD}/i/ims/auth/signin/ai`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        apihost: API_HOST,
      },
      body: JSON.stringify({
        username,
        password,
      }),
    });

    const res = await handleResponse(response);
    const data = normalizeResponse(res);

    if (data?.token) {
      localStorage.setItem("authToken", data.token);
    }

    if (data?.user) {
      localStorage.setItem("user", JSON.stringify(data.user));
    }

    if (data?.client) {
      localStorage.setItem("client", JSON.stringify(data.client));
    }

    return data;
  },

  getProfile: async () => {
    const response = await fetch(`${API_BASE_URL}/users/profile`, {
      headers: getAuthHeaders(),
    });

    return handleResponse(response);
  },

  updateProfile: async (userData) => {
    const response = await fetch(`${API_BASE_URL}/users/profile`, {
      method: "PUT",
      headers: getAuthHeaders(),
      body: JSON.stringify(userData),
    });

    return handleResponse(response);
  },

  // 1334 API
  request: async (endpoint, options = {}) => {
    const { headers, ...restOptions } = options;
    const isFormData = restOptions.body instanceof FormData;

    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      ...restOptions,
      headers: {
        ...getAuthHeaders(isFormData, true),
        ...headers,
      },
    });

    return handleResponse(response);
  },

  // 1333 API: apihost header अपने आप जाएगा
  request_old: async (endpoint, options = {}) => {
    const { headers, ...restOptions } = options;
    const isFormData = restOptions.body instanceof FormData;

    const response = await fetch(`${API_BASE_URL_OLD}${endpoint}`, {
      ...restOptions,
      headers: {
        ...getAuthHeaders(isFormData, true),
        ...headers,
      },
    });

    return handleResponse(response);
  },

  abc_request: async (endpoint, options = {}) => {
    const { headers, ...restOptions } = options;
    const isFormData = restOptions.body instanceof FormData;

    const response = await fetch(`${ABC_BASE_URL}${endpoint}`, {
      ...restOptions,
      headers: {
        ...getAuthHeaders(isFormData),
        ...headers,
      },
    });

    return handleResponse(response);
  },
};

export default apiService;

// import useAuthStore from "../store/authStore";

// const API_BASE_URL =
//   process.env.REACT_APP_API_BASE_URL || "http://localhost:1334/api";
// const API_BASE_URL_OLD =
//   process.env.REACT_APP_API_BASE_URL_OLD || "http://localhost:1333/api";
// const ABC_BASE_URL = "https://abcschool.institute.org.in/api";

// const getLocalJson = (key) => {
//   try {
//     const value = localStorage.getItem(key);
//     return value ? JSON.parse(value) : null;
//   } catch (error) {
//     return null;
//   }
// };

// const normalizeResponse = (res) => {
//   return res?.data || res;
// };

// const handleResponse = async (response) => {
//   let data = null;

//   try {
//     data = await response.json();
//   } catch (error) {
//     data = null;
//   }

//   if (!response.ok) {
//     if (response.status === 401) {
//       useAuthStore.getState().logout();
//     }

//     throw new Error(
//       data?.message ||
//         data?.error?.message ||
//         data?.error ||
//         `API error: ${response.status} ${response.statusText}`,
//     );
//   }

//   return data;
// };

// const getAuthData = () => {
//   const state = useAuthStore.getState();

//   const storeUser = state?.user;
//   const storeClient = state?.client;
//   const storeToken = state?.token;

//   const localUser = getLocalJson("user");
//   const localClient = getLocalJson("client");
//   const localToken = localStorage.getItem("authToken");

//   const token =
//     storeToken ||
//     storeUser?.token ||
//     storeUser?.data?.token ||
//     storeUser?.user?.token ||
//     storeUser?.data?.user?.token ||
//     localToken;

//   const client = storeClient || localClient;

//   const clientId =
//     client?.id ||
//     client?._id ||
//     storeUser?.client ||
//     storeUser?.user?.client ||
//     localUser?.client;

//   return {
//     token,
//     client,
//     clientId,
//   };
// };
// const getAuthHeaders = (isFormData = false, includeApiHost = false) => {
//   const headers = {};

//   if (!isFormData) {
//     headers["Content-Type"] = "application/json";
//   }

//   const { token, clientId } = getAuthData();

//   if (token) {
//     headers["token"] = token;
//   }

//   // if (clientId) {
//   //   headers["client"] = clientId;
//   // }
//   if (includeApiHost) {
//     headers["apihost"] = API_HOST;
//   }
//   return headers;
// };

// const apiService = {
//   login: async (username, password) => {
//     const response = await fetch(`${API_BASE_URL_OLD}/i/ims/auth/signin/ai`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         username,
//         password,
//       }),
//     });

//     const res = await handleResponse(response);
//     const data = normalizeResponse(res);

//     if (data?.token) {
//       localStorage.setItem("authToken", data.token);
//     }

//     if (data?.user) {
//       localStorage.setItem("user", JSON.stringify(data.user));
//     }

//     if (data?.client) {
//       localStorage.setItem("client", JSON.stringify(data.client));
//     }

//     return data;
//   },

//   getProfile: async () => {
//     const response = await fetch(`${API_BASE_URL}/users/profile`, {
//       headers: getAuthHeaders(),
//     });

//     return handleResponse(response);
//   },

//   updateProfile: async (userData) => {
//     const response = await fetch(`${API_BASE_URL}/users/profile`, {
//       method: "PUT",
//       headers: getAuthHeaders(),
//       body: JSON.stringify(userData),
//     });

//     return handleResponse(response);
//   },

//   request: async (endpoint, options = {}) => {
//     const { headers, ...restOptions } = options;
//     const isFormData = restOptions.body instanceof FormData;

//     const response = await fetch(`${API_BASE_URL}${endpoint}`, {
//       ...restOptions,
//       headers: {
//         ...getAuthHeaders(isFormData),
//         ...headers,
//       },
//     });

//     return handleResponse(response);
//   },

//   request_old: async (endpoint, options = {}) => {
//     const { headers, ...restOptions } = options;
//     const isFormData = restOptions.body instanceof FormData;

//     const response = await fetch(`${API_BASE_URL_OLD}${endpoint}`, {
//       ...restOptions,
//       headers: {
//         ...getAuthHeaders(isFormData),
//         ...headers,
//       },
//     });

//     return handleResponse(response);
//   },

//   abc_request: async (endpoint, options = {}) => {
//     const { headers, ...restOptions } = options;
//     const isFormData = restOptions.body instanceof FormData;

//     const response = await fetch(`${ABC_BASE_URL}${endpoint}`, {
//       ...restOptions,
//       headers: {
//         ...getAuthHeaders(isFormData),
//         ...headers,
//       },
//     });

//     return handleResponse(response);
//   },
// };

// export default apiService;
